import { API } from '@/models/core'
import { Enum } from '@/helpers/enum'

export const SportsKind = new Enum({
  Cricket: 'cricket',
  Football: 'football',
  Kabaddi: 'kabaddi'
})

export class FantasyDraftPlayer {
  constructor (playerkey, points) {
    this.playerkey = playerkey
    this.credits = points
  }
}

export class FantasyDraft {
  constructor () {
    this.players = []
  }
  addPlayerDraft (player) {
    const found = this.players.some(e1 => e1.playerkey === player.playerkey)
    if (!found) {
      this.players.push(player)
    }
  }
  removePlayerDraft (index) {
    if (index > -1) {
      this.players.splice(index, 1)
    }
  }
}

export class CreditsHistory {
  static createFromJson (raw) {
    let history = new FantasyEditPoints()
    history = Object.assign(history, raw)
    return history
  }
    static fetchCreditHistory (key) {
      let params = {}
      return API.instance().get(`/workflow/fantasy-credit-variation/${key}/history/`, params).then((resp) => {
        return CreditsHistory.createFromJson(resp.data.data.history)
      })
    }
}

export class FantasyEditPoints {
  static createFromJson (raw) {
    let match = new FantasyEditPoints()
    match = Object.assign(match, raw)
    Object.keys(match).forEach((key) => {
      match[key].sport = SportsKind.parse(match[key].sport)
    })
    return match
  }
  
  static fetchRecentEdits () {
    let params = {}
    return API.instance().get(`/workflow/fantasy-credit-variation/recent/`, params).then((resp) => {
      return FantasyEditPoints.createFromJson(resp.data.data.recent)
    })
  }
}
